import React from 'react';
import { Grid, useTheme, useMediaQuery } from '@mui/material';
import UsageCircle from './UsageCircle';

export type UsageData = {
  limit: number | null;
  count: number;
  percentageUsed: number | null;
  percentageUsedColour: string;
  label: string;
  description: string;
};

type UsageCirclesGridProps = {
  usageData: UsageData[];
};

const UsageCirclesGrid: React.FC<UsageCirclesGridProps> = ({ usageData }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // Calculate circle size based on screen size
  const getCircleSize = () => {
    if (isSmallScreen) return 90;
    return 130;
  };

  const circleSize = getCircleSize();

  return (
    <Grid container spacing={2} sx={{ mt: 0.5, mb: 3 }}>
      {usageData.map((usage, index) => (
        <Grid
          item
          xs={6}
          sm={4}
          md={4}
          lg={2}
          key={`${usage.label}-${index}`}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <UsageCircle
            limit={usage.limit}
            count={usage.count}
            percentageUsed={usage.percentageUsed}
            percentageUsedColor={usage.percentageUsedColour}
            label={usage.label}
            size={circleSize}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default UsageCirclesGrid;
